import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto relative" data-id="element-189">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-[600px] bg-pink-100 blur-[120px] rounded-full pointer-events-none" data-id="element-190" />

      <div className="text-center mb-16 relative z-10" data-id="element-191">
        <div className="inline-flex flex-col items-center gap-3 mb-8" data-id="element-192">
          <div className="flex items-center gap-2 text-brand-danger font-bold bg-red-50 px-4 py-1.5 rounded-full text-sm" data-id="element-193">
            <span data-id="element-194">⏰</span> OFERTA DE LANZAMIENTO
          </div>
          <p className="text-gray-500 text-sm flex items-center gap-2" data-id="element-195">
            <span data-id="element-196">⚠️</span> Precio sube en cualquier momento
          </p>
        </div>

        <h2 className="font-display text-4xl md:text-5xl font-bold flex items-center justify-center gap-3 text-gray-900" data-id="element-197">
          <span data-id="element-198">💎</span> ELEGÍ TU SISTEMA
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto relative z-10" data-id="element-199">
        {/* Basic Plan */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-pink-200 rounded-3xl p-8 flex flex-col shadow-sm" data-id="element-200">
          <div className="mb-8" data-id="element-201">
            <h3 className="text-2xl font-bold flex items-center gap-2 mb-2 text-gray-900" data-id="element-202">
              <span data-id="element-203">📘</span> SISTEMA FITNESS COMPLETO
            </h3>
            <p className="text-gray-500" data-id="element-204">
              Ideal para: mamás que quieren resultados reales
            </p>
          </div>

          <ul className="space-y-4 mb-8 flex-grow" data-id="element-205">
            <li className="flex items-center gap-3 text-gray-600" data-id="element-206">
              <Check size={20} className="text-brand-success" data-id="element-207" /> 6 Tomos
              completos
            </li>
            <li className="flex items-center gap-3 text-gray-600" data-id="element-208">
              <Check size={20} className="text-brand-success" data-id="element-209" /> 6 Bonos
              estratégicos
            </li>
          </ul>

          <div className="mb-8" data-id="element-210">
            <p className="text-gray-400 line-through text-lg mb-1" data-id="element-211">$49.000</p>
            <div className="flex items-baseline gap-2" data-id="element-212">
              <span className="text-4xl md:text-5xl font-black text-gray-900" data-id="element-213">
                $19.990
              </span>
              <span className="text-xl text-gray-500 font-medium" data-id="element-214">ARS</span>
            </div>
          </div>

          <a href="https://checkout.cmdigitalpro.online/cart/54037970682140:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-pink-100 hover:bg-pink-200 text-gray-900 font-bold text-lg py-4 px-6 rounded-xl transition-colors border border-pink-300" data-id="element-215">
            👉 QUIERO EL SISTEMA COMPLETO
          </a>
        </motion.div>

        {/* Premium Plan (Upsell) */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-white to-pink-50 border-2 border-brand-accent rounded-3xl p-8 flex flex-col relative transform lg:-translate-y-4 shadow-[0_0_40px_rgba(233,30,140,0.15)]" data-id="element-216">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-white font-bold px-6 py-1.5 rounded-full text-sm flex items-center gap-1 shadow-lg" data-id="element-217">
            ⭐ RECOMENDADO
          </div>

          <div className="mb-8 mt-2" data-id="element-218">
            <h3 className="text-2xl font-bold flex items-center gap-2 mb-2 text-brand-accent" data-id="element-219">
              <span data-id="element-220">🏆</span> SISTEMA + PLAN PERSONALIZADO
            </h3>
            <p className="text-gray-500" data-id="element-221">
              Ideal para: resultados más rápidos y sin pensar
            </p>
          </div>

          <ul className="space-y-4 mb-8 flex-grow" data-id="element-222">
            <li className="flex items-center gap-3 text-gray-600" data-id="element-223">
              <Check size={20} className="text-brand-success" data-id="element-224" /> 6 Tomos
              completos
            </li>
            <li className="flex items-center gap-3 text-gray-600" data-id="element-225">
              <Check size={20} className="text-brand-success" data-id="element-226" /> 6 Bonos
              estratégicos
            </li>
            <li className="flex items-center gap-3 text-gray-900 font-bold bg-pink-100 p-3 rounded-lg border border-pink-200" data-id="element-227">
              <Check size={20} className="text-brand-accent" data-id="element-228" /> Plan
              Personalizado 90D
            </li>
          </ul>

          <div className="mb-8" data-id="element-229">
            <p className="text-gray-400 line-through text-lg mb-1" data-id="element-230">$69.000</p>
            <div className="flex items-baseline gap-2" data-id="element-231">
              <span className="text-4xl md:text-5xl font-black text-brand-accent" data-id="element-232">
                $27.990
              </span>
              <span className="text-xl text-gray-500 font-medium" data-id="element-233">ARS</span>
            </div>
          </div>

          <a href="https://checkout.cmdigitalpro.online/cart/54037972091164:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(233,30,140,0.3)]" data-id="element-234">
            👉 QUIERO EL SISTEMA + PLAN PERSONALIZADO
          </a>
        </motion.div>
      </div>
    </section>;
}